import type { LocationKind, MarkerCategory, MissionKind, MissionStatus, Role } from '@apos/shared';
import type { ChipTone, IconName } from '../components/ui';

export const MISSION_KINDS: Array<{ value: MissionKind; label: string }> = [
  { value: 'flight_test', label: 'Flight test' },
  { value: 'acoustics', label: 'Acoustics' },
  { value: 'airport_ops', label: 'Airport ops' },
  { value: 'air_to_air', label: 'Air-to-air' },
  { value: 'remote', label: 'Remote shoot' },
  { value: 'multicam', label: 'Multicam' },
  { value: 'demo', label: 'Demo' },
  { value: 'other', label: 'Other' },
];

export const kindLabel = (k: MissionKind) => MISSION_KINDS.find((x) => x.value === k)?.label ?? k;

export const KIND_ICON: Record<MissionKind, IconName> = {
  flight_test: 'aircraft',
  acoustics: 'signal',
  airport_ops: 'map',
  air_to_air: 'a2a',
  remote: 'pin',
  multicam: 'camera',
  demo: 'sim',
  other: 'grid',
};

export const STATUS_TONE: Record<MissionStatus, ChipTone> = { live: 'live', planned: 'neutral', ended: 'neutral' };
export const STATUS_LABEL: Record<MissionStatus, string> = { live: 'LIVE', planned: 'PLANNED', ended: 'ENDED' };

export const ROLE_LABEL: Record<Role, string> = { owner: 'Owner', producer: 'Producer', crew: 'Crew', viewer: 'Viewer' };

export const LOCATION_KIND_LABEL: Record<LocationKind, string> = {
  camera_site: 'Camera site',
  staging: 'Staging',
  basecamp: 'Basecamp',
  landing_zone: 'Landing zone',
  poi: 'Point of interest',
  hazard: 'Hazard',
  parking: 'Parking',
};

export const MARKER_LABEL: Record<MarkerCategory, string> = {
  pass: 'Pass',
  hero: 'Hero',
  good: 'Good',
  missed: 'Missed',
  issue: 'Issue',
  note: 'Note',
};

const ROLE_RANK: Record<Role, number> = { viewer: 0, crew: 1, producer: 2, owner: 3 };
/** true if `role` is at least `min`. */
export const atLeast = (role: Role | undefined, min: Role) => (role ? ROLE_RANK[role] >= ROLE_RANK[min] : false);
